import React from 'react';
import ExtractJobForm from './ExtractJobForm';

interface Divisor {
  id: number;
  divisor_type: string;
  title: string;
  content_preview: string;
}

interface ExtractJob {
  id?: number;
  name?: string;
  start_page?: number;
  end_page?: number;
  extract_prompt?: string;
  json_map?: string;
  divisor_types?: string[];
  response_payload?: any;
  divisors?: Divisor[];
}

interface Document {
  id: number;
  name: string;
  page_count: number;
  divisor_types?: string[];
  extract_jobs: ExtractJob[];
}

interface ExtractJobNewProps {
  document: Document;
  extractJob: ExtractJob;
  divisorTypes: string[];
}

export default function ExtractJobNew({ document, extractJob, divisorTypes }: ExtractJobNewProps) {
  return (
    <ExtractJobForm 
      document={document}
      extractJob={extractJob}
      divisorTypes={divisorTypes}
    />
  );
}